export default __webpack_public_path__ + "static/media/Male_lion_Namibia_Anonymous_30_x_40.e7ac8551.jpg";